<template>
  <div class="transportOrderList">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @setSearchModal="setSearchModal"
    ></SiruiSearch>
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @dblclickEvent="dblclickEvent"
        @setCheckboxRow="setCheckboxRow"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.field === 'deliveryStatus'">
              {{ deliveryStatusData[scope.row[item.field]] }}
            </span>
            <span v-else-if="item.field === 'deliveryType'">
              {{ deliveryTypeData[scope.row[item.field]] }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>
<script>
  // import axios from 'axios';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import MASTER_API from '@/api/masterData/company.js';
  import API from '@/api/logisticsCenter/transportOrder';
  import { mapState } from 'vuex';
  import tableMixins from '@/common/mixins/table.js';

  export default {
    name: 'transportOrderList',
    mixins: [tableMixins],
    components: {
      SiruiTable,
      SiruiSearch,
    },
    data() {
      return {
        load: false,
        query: {
          deliveryNo: null,
          instructionNo: null,
          salesLadingNo: null,
          transferSlipNo: null,
          otherNo: null,
          deliveryProductName: null,
          startDeliveryStartDate: null,
          endDeliveryStartDate: null,
          carrierName: null,
          pickupStorageName: null,
          shiptoStorageName: null,
          deliveryContactPerson: null,
          pickupStorageAddress: null,
          shiptoStorageAddress: null,
          deliveryDepartment: null,
          salesmanName: null,
          deliveryStatus: null,
          deliveryType: null,
        },
        menuButtonList: [],
        tableData: [],
        deliveryStatusData: [],
        deliveryTypeData: [],
        columnList: [],
        columnListDefault: [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          {
            field: 'deliveryNo',
            title: 'transportOrderList.table.deliveryNo',
            visible: true,
          },
          {
            field: 'deliveryStatus',
            title: 'transportOrderList.table.deliveryStatus',
            visible: true,
          },
          {
            field: 'deliveryType',
            title: 'transportOrderList.table.deliveryType',
            visible: true,
          },
          {
            field: 'instructionNo',
            title: 'transportOrderList.table.instructionNo',
            visible: true,
          },
          {
            field: 'salesLadingNo',
            title: 'transportOrderList.table.salesLadingNo',
            visible: true,
          },
          {
            field: 'transferSlipNo',
            title: 'transportOrderList.table.transferSlipNo',
            visible: true,
          },
          {
            field: 'otherNo',
            title: 'transportOrderList.table.otherNo',
            visible: true,
          },
          {
            field: 'deliveryStartDate',
            title: 'transportOrderList.table.deliveryStartDate',
            visible: true,
          },
          {
            field: 'deliveryProductNo',
            title: 'transportOrderList.table.deliveryProductName',
            visible: true,
          },
          {
            field: 'deliveryQuantity',
            title: 'transportOrderList.table.deliveryQuantity',
            visible: true,
          },
          {
            field: 'carrierName',
            title: 'transportOrderList.table.carrierName',
            visible: true,
          },
          {
            field: 'pickupStorageName',
            title: 'transportOrderList.table.pickupStorageName',
            visible: true,
          },
          {
            field: 'shiptoStorageName',
            title: 'transportOrderList.table.shiptoStorageName',
            visible: true,
          },
          {
            field: 'deliveryContactPerson',
            title: 'transportOrderList.table.deliveryContactPerson',
            visible: true,
          },
          {
            field: 'deliveryContactTelephone',
            title: 'transportOrderList.table.deliveryContactTelephone',
            visible: true,
          },
          {
            field: 'pickupStorageAddress',
            title: 'transportOrderList.table.pickupStorageAddress',
            visible: true,
          },
          {
            field: 'shiptoStorageAddress',
            title: 'transportOrderList.table.shiptoStorageAddress',
            visible: true,
          },
          {
            field: 'deliveryExpenseUnitPrice',
            title: 'transportOrderList.table.deliveryExpenseUnitPrice',
            visible: true,
          },
          {
            field: 'otherExpense',
            title: 'transportOrderList.table.otherExpense',
            visible: true,
          },
          {
            field: 'salesmanName',
            title: 'transportOrderList.table.salesmanName',
            visible: true,
          },
          {
            field: 'deliveryDepartment',
            title: 'transportOrderList.table.deliveryDepartment',
            visible: true,
          },
          {
            field: 'shiptoDemand',
            title: 'transportOrderList.table.shiptoDemand',
            visible: true,
          },
        ],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      searchColumns() {
        return [
          // 发货指令号
          {
            prop: 'instructionNo',
            name: this.$t('transportOrderList.search.instructionNo'),
            type: 'input',
            placeholder: this.$t('transportOrderList.search.instructionNoPlaceholder'),
          },
          // 销售提单号
          {
            prop: 'salesLadingNo',
            name: this.$t('transportOrderList.search.salesLadingNo'),
            type: 'input',
            placeholder: this.$t('transportOrderList.search.salesLadingNoPlaceholder'),
          },
          // 库存调拨单号
          {
            prop: 'transferSlipNo',
            name: this.$t('transportOrderList.search.transferSlipNo'),
            type: 'input',
            placeholder: this.$t('transportOrderList.search.transferSlipNoPlaceholder'),
          },
          // 其他单号
          {
            prop: 'otherNo',
            name: this.$t('transportOrderList.search.otherNo'),
            type: 'input',
            placeholder: this.$t('transportOrderList.search.otherNoPlaceholder'),
          },
          // 物流运输单号
          {
            prop: 'deliveryNo',
            name: this.$t('transportOrderList.search.deliveryNo'),
            type: 'input',
            placeholder: this.$t('transportOrderList.search.deliveryNoPlaceholder'),
          },
          // 商品
          {
            prop: 'deliveryProductName',
            name: this.$t('transportOrderList.search.deliveryProductName'),
            type: 'searchTableSpec',
            searchType: 'goodsDetail',
            width: '800',
            isMultiple: true,
            placeholder: this.$t('transportOrderList.search.deliveryProductNamePlaceholder'),
          },
          // 起运日期开始日期
          {
            prop: 'startDeliveryStartDate',
            name: this.$t('transportOrderList.search.startDeliveryStartDate'),
            type: 'startDaterangePicker',
            placeholder: this.$t('transportOrderList.search.startDeliveryStartDatePlaceholder'),
          },
          // 起运日期结束日期
          {
            prop: 'endDeliveryStartDate',
            name: this.$t('transportOrderList.search.endDeliveryStartDate'),
            type: 'endDaterangePicker',
            placeholder: this.$t('transportOrderList.search.endDeliveryStartDatePlaceholder'),
          },
          // 承运方
          {
            prop: 'carrierName',
            name: this.$t('transportOrderList.search.carrierName'),
            type: 'input',
            searchType: 'supplier',
            width: '800',
            isMultiple: true,
            placeholder: this.$t('transportOrderList.search.carrierNamePlaceholder'),
          },
          // 提货仓库
          {
            prop: 'pickupStorageName',
            name: this.$t('transportOrderList.search.pickupStorageName'),
            type: 'input',
            searchType: 'warehouse',
            width: '800',
            isMultiple: true,
            placeholder: this.$t('transportOrderList.search.pickupStorageNamePlaceholder'),
          },
          // 收货仓库
          {
            prop: 'shiptoStorageName',
            name: this.$t('transportOrderList.search.shiptoStorageName'),
            type: 'input',
            searchType: 'warehouse',
            width: '800',
            isMultiple: true,
            placeholder: this.$t('transportOrderList.search.shiptoStorageNamePlaceholder'),
          },
          // 运输联系人
          {
            prop: 'deliveryContactPerson',
            name: this.$t('transportOrderList.search.deliveryContactPerson'),
            type: 'input',
            placeholder: this.$t('transportOrderList.search.deliveryContactPersonPlaceholder'),
          },
          // 提货仓库地址
          {
            prop: 'pickupStorageAddress',
            name: this.$t('transportOrderList.search.pickupStorageAddress'),
            type: 'input',
            placeholder: this.$t('transportOrderList.search.pickupStorageAddressPlaceholder'),
          },
          // 送达仓库地址
          {
            prop: 'shiptoStorageAddress',
            name: this.$t('transportOrderList.search.shiptoStorageAddress'),
            type: 'input',
            placeholder: this.$t('transportOrderList.search.shiptoStorageAddressPlaceholder'),
          },
          // 部门
          {
            prop: 'deliveryDepartment',
            name: this.$t('transportOrderList.search.deliveryDepartment'),
            type: 'treeSelect',
            apiUrl: MASTER_API.LIST_COMPANY_API,
            apiData: {
              tenantCode: this.userInfo.userInfo.tenantCode,
              adminFlag: this.userInfo.userInfo.adminFlag,
            },
            isName: true,
            clearable: false,
          },
          // 业务员
          {
            prop: 'salesmanName',
            name: this.$t('transportOrderList.search.salesmanName'),
            type: 'searchTableSpec',
            searchType: 'personnel',
            width: '800',
            isMultiple: true,
            placeholder: this.$t('transportOrderList.search.salesmanNamePlaceholder'),
          },
          // 状态 待确认/已保存/已作废/已确认/已撤销
          {
            prop: 'deliveryStatus',
            name: this.$t('transportOrderList.search.deliveryStatus'),
            type: 'select',
            placeholder: this.$t('transportOrderList.search.deliveryStatusPlaceholder'),
            options: [
              { value: '1', label: '待确认' },
              { value: '2', label: '已保存' },
              { value: '3', label: '已作废' },
              { value: '4', label: '已确认' },
              { value: '5', label: '已撤销' },
            ],
          },
          // 运输类型 自提(买),配送(卖),调拨,其他(如退换货)
          {
            prop: 'deliveryType',
            name: this.$t('transportOrderList.search.deliveryType'),
            type: 'select',
            placeholder: this.$t('transportOrderList.search.deliveryTypePlaceholder'),
            options: [
              { value: '1', label: '自提' },
              { value: '2', label: '配送' },
              { value: '3', label: '调拨' },
              { value: '4', label: '其他' },
            ],
          },
        ];
      },
    },
    /**页面必要代码Start */
    mounted() {
      this.getDic();
      this.getData();
      this.getButtonList();
    },
    methods: {
      setSearchModal(model, row) {
        console.log('mdoel', row, model);
      },
      getDic() {
        let deliveryStatusList = [
          {
            label: '待确认',
            value: '1',
          },
          {
            label: '已保存',
            value: '2',
          },
          {
            label: '已作废',
            value: '3',
          },
          {
            label: '已确认',
            value: '4',
          },
          {
            label: '已撤销',
            value: '5',
          },
        ];
        let deliveryTypeList = [
          {
            label: '自提',
            value: '1',
          },
          {
            label: '配送',
            value: '2',
          },
          {
            label: '调拨',
            value: '3',
          },
          {
            label: '其他',
            value: '4',
          },
        ];
        deliveryStatusList.map((item) => {
          return (this.deliveryStatusData[item['value']] = item['label']);
        });
        deliveryTypeList.map((item) => {
          return (this.deliveryTypeData[item['value']] = item['label']);
        });
      },
      //获取数据
      getData() {
        // this.$refs.siruiTable.clearCheckboxReserve();
        this.load = true;
        let query = this.$refs.siruiSearch.query;
        query.pageSize = this.$refs.siruiTable.page.pageSize;
        query.pageNum = this.$refs.siruiTable.page.pageNum;
        query = Object.assign(query, {
          // deliveryProductName: query.deliveryProductName
          //   ? query.deliveryProductName[0].detailProductDisplayName
          //   : "",
          // productNo: query.deliveryProductName
          //   ? query.deliveryProductName[0].productDetailCode
          //   : "",

          productNo:
            query.deliveryProductName && query.deliveryProductName[0]
              ? query.deliveryProductName[0].allProductDetailCode
                ? query.deliveryProductName[0].allProductDetailCode
                : query.deliveryProductName[0].productDetailCode
              : '',
          // carrierName: query.carrierName
          //   ? query.carrierName[0].partnerZhName
          //   : "",
          // pickupStorageName: query.pickupStorageName
          //   ? query.pickupStorageName[0].storageName
          //   : "",
          // shiptoStorageName: query.shiptoStorageName
          //   ? query.shiptoStorageName[0].storageName
          //   : "",
          salesmanName: query.salesmanName ? query.salesmanName[0].personName : '',
        });
        delete query.deliveryProductName;
        this.$axios.post(API.LIST_DELIVERY_PAGE, query).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.list;
            this.setCheckboxRow();
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      chooseClick(type) {
        if (type === 'addOrder') {
          let path = {
            path: '/logistics/transportOrderAdd',
            name: 'transportOrderAdd',
            meta: {
              keepAlive: true,
              title: '物流运输单创建',
            },
            query: { isEdit: false, status: '0', version: '' },
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        }
      },
      // 设置是否已经结算
      setCheckboxRow() {
        let checkedList = [];
        if (this.tableData.length !== 0) {
          this.tableData.map((item) => {
            if (item.settle == 1) {
              checkedList.push(item);
            }
          });
          this.$refs.siruiTable.setCheckboxRow(checkedList, true);
        }
      },
      dblclickEvent(tableRow) {
        let path = {
          path: '/logistics/transportOrderEdit',
          name: 'transportOrderEdit',
          meta: {
            keepAlive: true,
            title: '物流运输单编辑',
          },
          query: {
            isEdit: true,
            status: tableRow.row.deliveryStatus,
            version: tableRow.row.version,
            deliveryNo: tableRow.row.deliveryNo,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
    },
  };
</script>
